<template>
  <div class="client">
    <div class="icon-box">
      <div class="img-b offi" @mouseenter="showOffiImg = false" @mouseleave="showOffiImg = true">
        <img src="@/assets/backtop/微信_常规.png" alt="" v-if="showOffiImg">
        <img src="@/assets/backtop/微信_点击.png" alt="" v-else>
        <div class="official">
            <img src="@/assets/backtop/WHMM公众号.png" />
            <div class="official-text">扫描二维码</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="img-b contact" @mouseenter="showContactImg = false" @mouseleave="showContactImg = true">
        <img src="@/assets/backtop/电话_常规.png" alt="" v-if="showContactImg">
        <img src="@/assets/backtop/电话_点击.png" alt="" v-else>
        <div class="callgroup">
          <div class="call-head">
            <div class="imgbox">
              <img src="@/assets/backtop/电话.svg" alt="">
            </div>
            <span>联系电话</span>
          </div>
          <div class="calls">027-5930 3092</div>
          <div class="calls">027-5930 3093</div>
          <div class="calls">027-5930 3094</div>
        </div>
      </div>

    </div>    
  </div>
</template>

<script>
export default {
  name: 'BackTop',
  data () {
    return {
      showContactImg:true,
      showOffiImg:true
    }
  },
  mounted(){

  }
}
</script>

<style lang="less" scoped>
.client {
  position: fixed;
  top: 54%;
  right: 4px;
  background-color: #ffffff;
  border-radius: 16px 8px 8px 16px;
  box-shadow: 0px 0px 3px 1px #e3e3e3;
  .icon-box{
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 20px 10px;
    .img-b{
      width: 26px;
      height: 26px;
      padding: 5px;
      cursor: pointer;
      position: relative;
      &>img{
        width: 100%;
        height: 100%;
      }
    }
    .img-b.contact:hover{
      .callgroup{
        opacity: 1;
      }
    }
    .img-b.offi:hover{
      .official{
        opacity: 1;
      }
    }
    .line{
      width: 100%;
      background-color: #B9B9B9;
      height: 1px;
    }
  }
}
.callgroup{
    box-sizing: border-box;
    position: absolute;
    border-radius: 10px;
    opacity: 0;
    background-color: #fff;
    color: #000;
    width: 185px;
    left: -600%;
    top: -184%;
    padding: 10px;
    transition: opacity .3s ease-out;
    pointer-events: none;
    box-shadow: 0 0 3px 1px #dbdbdb;
    font-size: 14px;
    &::after{
      content: '';
      position: absolute;
      width: 20px;
      height: 20px;
      transform: rotateZ(45deg) translateY(-50%);
      background-color: #ffffff;
      right: -3px;
      top: 50%;
      box-shadow: 2px -2px 3px 1px #dbdbdb;
    }
    .call-head{
      display: flex;
      gap: 10px;
      margin-bottom: 16px;
      .imgbox{
        width: 20px;
        height: 20px;
        img{
          width:100%;
          height: 100%;
        }
      }
    }
    .calls{
      margin-bottom: 10px;
      padding-left: 30px;
    }
}
.official{
  box-sizing: border-box;
  position: absolute;
  border-radius: 10px;
  opacity: 0;
  background-color: #fff;
  color: #000;
  width: 185px;
  left: -600%;
  top: -230%;
  padding: 10px;
  text-align: center;
  transition: opacity .3s ease-out;
  pointer-events: none;
  box-shadow: 0 0 6px 2px #dbdbdb;
  font-size: 14px;
  img{
    width: 125px;
    height: 125px;
  }
  &::after{
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    transform: rotateZ(45deg) translateY(-50%);
    background-color: #ffffff;
    right: -3px;
    top: 50%;
    box-shadow: 2px -2px 2px 1px #dbdbdb;
  }
}
</style>
